import Button from 'components/Button';
import Field from 'components/Form/Field';
import {FC} from 'react';
import {useFieldArray, useFormContext} from 'react-hook-form';
import {c} from 'ttag';

import ApproverEntry from './entry';
import {ApprovalGroup} from './types';

const ApproversInput: FC<{
    label?: string;
    name: string;
    options: ApprovalGroup[];
    required?: boolean;
}> = ({label, name, options, required}) => {
    const methods = useFormContext();
    const fieldMethods = useFieldArray<
        Record<string, {value: null | string}[]>
    >({
        control: methods.control,
        name: name,
    });
    const {append, fields} = fieldMethods;

    return (
        <Field label={label} name={name} required={required} type="select">
            <div className="flex flex-col gap-2">
                {fields.length === 0 && (
                    <ApproverEntry
                        index={0}
                        name={name}
                        options={options}
                        required={required}
                        showButtons={true}
                        {...fieldMethods}
                    />
                )}
                {fields.map((field, index) => (
                    <ApproverEntry
                        index={index}
                        key={field.id}
                        name={name}
                        options={options}
                        required={required}
                        showButtons={fields.length > 1}
                        {...fieldMethods}
                    />
                ))}
                <div>
                    <Button
                        data-testid="add-approver"
                        kind="secondary"
                        onClick={() => append({value: null})}
                    >{c('components').t`Add Approver`}</Button>
                </div>
            </div>
        </Field>
    );
};

export default ApproversInput;
